import { message } from 'antd';
import { RcFile } from 'antd/es/upload';

export const validateFileSize = (file: RcFile, maxFileSize: number): boolean => {
  if (file.size > maxFileSize) {
    message.error(`File "${file.name}" quá lớn. Kích thước tối đa là ${formatFileSize(maxFileSize)}.`);
    return false;
  }
  return true;
};
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
};
